export default "__VITE_ASSET__QurQKGId__"